module.exports = __webpack_public_path__ + "img/0Q3A8622_FoamcoreMatted.1b5a1cc6.jpg";